import { useContext } from 'react';
import { viewerApiContext, ViewerApiContext } from './ViewerContext';

const useViewerApiContext = (): ViewerApiContext => {
  const viewerTools = useContext<ViewerApiContext>(viewerApiContext);
  return viewerTools;
};

export default useViewerApiContext;
